// extracted by mini-css-extract-plugin
export default {"wrapper":"TokenCounter_wrapper__EEbnJ","box":"TokenCounter_box__qDr1H","img":"TokenCounter_img__pQ+3p","count":"TokenCounter_count__AZ8lT"};